import { createTheme } from '@mui/material/styles';
import { AlertClassKey } from '@mui/material/Alert';
// https://github.com/mui-org/material-ui/issues/19427#issuecomment-597548533
declare module '@mui/material/styles/overrides' {
  export interface ComponentNameToClassKey {
    MuiAlert: AlertClassKey;
  }
}

const theme = createTheme({
  palette: {
    primary: {
      main: '#004681',
      light: '#4771b1',
      dark: '#002054',
    },
  },
  components:{
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      }
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          margin: '8px',
          padding: '6px',
        },
        icon: {
          padding: '0',
        },
        message: {
          padding: '0',
        },
      }
    },
    MuiCssBaseline: {
      styleOverrides: {
        // '@global': {
          body:{
            lineHeight: 1.2,
          },
          html: {
            '--ag-checkbox-checked-color': '#0a3e94',
          },
          '*::-webkit-scrollbar': {
            width: '0.6em',
            height: '0.5em',
          },
          '*::-webkit-scrollbar-track': {
            webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
            backgroundColor: '#ECECEC',
            borderRadius: '10px',
          },
          '*::-webkit-scrollbar-thumb': {
            backgroundColor: '#999999',
            borderRadius: '10px',
          },
          '.ag-input-field-label': {
            whiteSpace: 'normal!important' as 'normal',
            wordBreak: 'break-all',
            width: '90%',
            lineHeight: 0.9,
          },
        // }
      },
    },
  }
 
  // overrides: {
  //   MuiButton: {
  //     root: {
  //       textTransform: 'none',
  //     },
  //   },
  //   MuiAlert: {
  //     root: {
  //       margin: '8px',
  //       padding: '6px',
  //     },
  //     icon: {
  //       padding: '0',
  //     },
  //     message: {
  //       padding: '0',
  //     },
  //   },
  //   MuiCssBaseline: {
  //     '@global': {
  //       html: {
  //         '--ag-checkbox-checked-color': '#0a3e94',
  //       },
  //       '*::-webkit-scrollbar': {
  //         width: '0.6em',
  //         height: '0.5em',
  //       },
  //       '*::-webkit-scrollbar-track': {
  //         '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)',
  //         backgroundColor: '#ECECEC',
  //         borderRadius: '10px',
  //       },
  //       '*::-webkit-scrollbar-thumb': {
  //         backgroundColor: '#999999',
  //         borderRadius: '10px',
  //       },
  //       '.ag-input-field-label': {
  //         whiteSpace: 'normal!important' as 'normal',
  //         wordBreak: 'break-all',
  //         width: '90%',
  //         lineHeight: 0.9,
  //       },
  //     },
  //   },
  // },
});

export default theme;
